import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { LogoLockup } from "@/components/Logo";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const nav = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling"); // polling | paid | failed

  useEffect(() => {
    if (!sessionId) { setStatus("failed"); return; }
    let cancelled = false;
    let attempts = 0;
    const tick = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (cancelled) return;
        if (data.payment_status === "paid") { setStatus("paid"); toast.success("Payment received. Welcome to the Founding Dealer cohort."); return; }
        if (data.payment_status === "failed" || data.payment_status === "expired") { setStatus("failed"); return; }
        if (attempts >= 15) { setStatus("failed"); return; }
        setTimeout(tick, 2000);
      } catch { if (!cancelled) { if (attempts >= 15) { setStatus("failed"); return; } setTimeout(tick, 2000); } }
    };
    tick();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[var(--tm-off)] flex items-center justify-center p-5">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Link to="/"><LogoLockup /></Link></div>
        <div className="tm-card p-8 bg-white text-center" data-testid={`payment-status-${status}`}>
          {status === "polling" && (<><Loader2 className="mx-auto animate-spin text-[#3B424B]" size={28} /><h1 className="mt-4 text-xl font-bold">Confirming your payment…</h1><p className="mt-2 text-sm text-[#3B424B]">This usually takes a few seconds.</p></>)}
          {status === "paid" && (<><CheckCircle2 className="mx-auto text-[#14624A]" size={36} /><h1 className="mt-4 text-2xl font-bold">Welcome to the cohort.</h1><p className="mt-2 text-sm text-[#3B424B]">Your Founding Dealer subscription is active. We'll be in touch within one business day to onboard your dealership.</p><button className="tm-btn-primary w-full mt-6" onClick={() => nav("/app")} data-testid="payment-goto-app">Go to dashboard</button></>)}
          {status === "failed" && (<><XCircle className="mx-auto text-[#D9381E]" size={36} /><h1 className="mt-4 text-2xl font-bold">We couldn't confirm the payment.</h1><p className="mt-2 text-sm text-[#3B424B]">No charge was completed. You can try again from the pricing page.</p><button className="tm-btn-outline w-full mt-6" onClick={() => nav("/#pricing")} data-testid="payment-retry">Back to pricing</button></>)}
        </div>
      </div>
    </div>
  );
}
